import { render, staticRenderFns } from "./TemplateDetailTabs.vue?vue&type=template&id=26f5e4d8&scoped=true"
import script from "./TemplateDetailTabs.vue?vue&type=script&lang=js"
export * from "./TemplateDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailTabs.vue?vue&type=style&index=0&id=26f5e4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f5e4d8",
  null
  
)

export default component.exports